/* =========================================================================
   NUTROVATE header
   Framework free and independent of Horizon's private modules. It also takes
   over the three CSS custom properties layout/theme.liquid would normally
   set from <header-component>, which no longer exists on the page.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__nvHeaderInit) return;
  window.__nvHeaderInit = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function boot() {
    var hd = $('.nv-hd');
    if (!hd) return;

    /* ---- header height custom properties -------------------------------
       theme.liquid bails out when it cannot find <header-component>, which
       leaves --header-height unset and breaks any Horizon rule that offsets
       against it. Set them here instead. -------------------------------- */
    function measure() {
      var group = $('#header-group') || hd.parentElement;
      var h = hd.offsetHeight;
      document.body.style.setProperty('--header-height', h + 'px');
      /* Shopify wraps the section in .shopify-section, so the header is a
         grandchild of the group, not a child. Skip whichever child contains
         it or the header gets counted twice. */
      var own = hd.closest('.shopify-section') || hd;
      var total = 0;
      if (group) {
        Array.prototype.forEach.call(group.children, function (el) {
          if (el !== own && el !== hd && !el.contains(hd) && el instanceof HTMLElement) {
            total += el.offsetHeight;
          }
        });
      }
      document.body.style.setProperty('--header-group-height', (total + h) + 'px');
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    }
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(hd);
    window.addEventListener('resize', measure);

    /* ---- search --------------------------------------------------------- */
    var search = $('.nv-hd__search', hd), searchBtn = $('[data-nv-search]', hd);
    if (search && searchBtn) {
      searchBtn.addEventListener('click', function () {
        var on = search.classList.toggle('is-on');
        searchBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on) { var i = $('input[name="q"]', search); if (i) i.focus(); }
        measure();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && search.classList.contains('is-on')) {
          search.classList.remove('is-on');
          searchBtn.setAttribute('aria-expanded', 'false');
          searchBtn.focus();
          measure();
        }
      });
    }

    /* ---- mobile drawer -------------------------------------------------- */
    var drawer = $('.nv-hd__drawer'), scrim = $('.nv-hd__scrim'),
        burger = $('[data-nv-burger]', hd), dclose = $('[data-nv-dclose]'), lastFocus = null;
    function openD() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-on'); scrim.classList.add('is-on');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (dclose) dclose.focus();
    }
    function closeD() {
      drawer.classList.remove('is-on'); scrim.classList.remove('is-on');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    if (burger && drawer && scrim) {
      burger.addEventListener('click', openD);
      scrim.addEventListener('click', closeD);
      if (dclose) dclose.addEventListener('click', closeD);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-on')) closeD();
      });
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = $$('a[href], button, select, input, [tabindex]:not([tabindex="-1"])', drawer)
          .filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    /* ---- cart count -----------------------------------------------------
       The bubble carries Horizon's own hooks, so scripts that already update
       the native bubble keep working. This listener is the reverse path: it
       reflects any cart event raised elsewhere on the page. --------------- */
    function paint(count) {
      if (typeof count !== 'number') return;
      $$('[data-nv-cart-count]').forEach(function (el) {
        el.textContent = count > 99 ? '99+' : String(count);
        el.classList.toggle('is-on', count > 0);
      });
      $$('.nv-hd .cart-bubble').forEach(function (b) {
        b.classList.toggle('visually-hidden', count === 0);
      });
    }
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (n) {
      document.addEventListener(n, function (e) {
        var c = e && e.detail && e.detail.cart;
        if (c && typeof c.item_count === 'number') paint(c.item_count);
        else refresh();
      });
    });
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.item_count); })
        .catch(function () {});
    }
    var seeded = hd.getAttribute('data-cart-count');
    if (seeded !== null && seeded !== '') paint(parseInt(seeded, 10));

    /* ---- mobile ticker cross fade --------------------------------------- */
    var ticks = $$('.nv-hd__tick', hd);
    if (ticks.length > 1) {
      var i = 0;
      ticks[0].classList.add('is-on');
      setInterval(function () {
        ticks[i].classList.remove('is-on');
        i = (i + 1) % ticks.length;
        ticks[i].classList.add('is-on');
      }, 3600);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* =========================================================================
   NUTROVATE cart drawer
   Replaces the cart page. The contents are rendered by Liquid and pulled in
   through the Section Rendering API rather than assembled from /cart.js,
   because Liquid can see the nvpdp short title metafield, the shop's money
   format and discount names, and the JSON API cannot.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__nvCartInit) return;
  window.__nvCartInit = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var SECTION = 'nv-cart-items';
  var root, scrim, body, foot, countEl, lastFocus = null, busy = false;

  function rootUrl() {
    var r = (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';
    return r.replace(/\/$/, '') + '/';
  }

  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('is-on');
    if (scrim) scrim.classList.add('is-on');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = $('[data-nv-cart-close]', root);
    if (c) c.focus();
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-on');
    if (scrim) scrim.classList.remove('is-on');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function paintCount(n) {
    if (countEl) countEl.textContent = n > 0 ? n + (n === 1 ? ' item' : ' items') : '';
    $$('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', n === 0); });
    $$('[ref="cartBubbleCount"],[data-nv-cart-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.classList.toggle('is-on', n > 0);
      el.classList.toggle('hidden', n === 0);
    });
  }

  /* Pull the rendered drawer contents and swap the two halves into place. */
  function refresh(openAfter) {
    return fetch(rootUrl() + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('[data-nv-cart-render]');
        if (!wrap) return;
        var items = wrap.querySelector('[data-part="items"]');
        var f = wrap.querySelector('[data-part="foot"]');
        if (items) body.innerHTML = items.innerHTML;
        if (f) {
          foot.innerHTML = f.innerHTML;
          foot.hidden = f.innerHTML.trim() === '';
        }
        paintCount(parseInt(wrap.getAttribute('data-count'), 10) || 0);
        if (openAfter) open();
      })
      .catch(function () {});
  }

  function change(line, qty) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return refresh(false).then(function () {
          /* Let the rest of the page know, but flag the source so this
             listener does not reopen the drawer off its own change. */
          ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (name) {
            document.dispatchEvent(new CustomEvent(name, {
              bubbles: true, detail: { cart: c, source: 'nv-cart-drawer' }
            }));
          });
        });
      })
      .catch(function () {})
      .finally(function () { busy = false; root.classList.remove('is-busy'); });
  }

  function boot() {
    root = $('#nvCart');
    if (!root) return;
    scrim = $('[data-nv-cart-scrim]');
    body = $('[data-nv-cart-body]', root);
    foot = $('[data-nv-cart-foot]', root);
    countEl = $('[data-nv-cart-n]', root);

    /* Tells the other nv scripts to skip their "added" toast: with a drawer
       opening, the toast is a second confirmation of the same thing. */
    window.__nvCartDrawer = true;

    $$('[data-nv-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-on')) close();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])', root)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nv-qty]');
      if (!btn) return;
      e.preventDefault();
      change(parseInt(btn.getAttribute('data-nv-qty'), 10),
             Math.max(0, parseInt(btn.getAttribute('data-to'), 10)));
    });

    /* Any link to the cart page opens the drawer instead. The href stays real,
       so it still works without JavaScript and on a middle click. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var href = a.getAttribute('href') || '';
      if (!/^(\/[a-z-]{2,5})?\/cart\/?($|\?)/.test(href)) return;
      e.preventDefault();
      refresh(true);
    });

    /* Something was added elsewhere on the page. */
    document.addEventListener('cart:update', function (e) {
      var d = e && e.detail;
      if (!d || d.source === 'nv-cart-drawer') return;
      var openIt = !!(d.source && d.source.indexOf('nv-') === 0);
      refresh(openIt);
    });

    refresh(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
